import CompanySearchInput from "./CompanySearchInput";
import useTranslation from "~/kernel/internationalization/useTranslation";
import StartPageContainer from "./StartPageContainer";

export default function Hero() {
  const { t } = useTranslation();
  return (
    <>
      <div className="relative py-3 md:py-10 ">
        <div className="absolute inset-0 bg-neutral-400 h-full flex flex-row rounded-b-xl shadow-inset-lg overflow-hidden">
          <div className="bg-gradient-to-r to-neutral-400 from-neutral-500 flex-1 h-full w-full"></div>
          <img
            src="/start-page-banner-xl.jpg"
            className="w-auto object-cover ml-auto h-full"
            alt={t("hero.alt")}
          />
          <a
            className="absolute bg-[rgba(0,0,0,0.5)] text-white text-xs opacity-80 py-2 px-3 rounded-tl-lg right-0 bottom-0 lg:block hidden"
            href="https://www.instagram.com/smilla_hundtrim/"
          >
            {t("hero.photoBy")} Smilla West
          </a>
        </div>
        <SearchSection />
      </div>
    </>
  );
}

function SearchSection() {
  const { t } = useTranslation();
  return (
    <StartPageContainer>
      <div className="bg-white rounded-lg relative p-12 border drop-shadow-xl border-y border-slate-200 lg:max-w-[40vw]">
        <div className="space-y-8 flex flex-col relative">
          <div className="max-w-md space-y-5">
            <div className="text-slate-800 text-3xl xl:text-5xl font-bold">
              {t("hero.titleStart")}
              <span className="text-primary">{t("hero.titleEmphasized")}</span>
              {t("hero.titleEnd")}
            </div>
            <p>{t("hero.description")}</p>
          </div>

          <div className="w-full">
            <CompanySearchInput />
          </div>
        </div>
      </div>
    </StartPageContainer>
  );
}
